import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef } from 'react';
import { observer } from 'mobx-react-lite';
import { Box, Flex, IconButton } from '@chakra-ui/react';
import { Svg } from '../../base';
import { useClickOutside, useToggle } from '../../../hooks';
import { OptionsContainer, ValueContainer } from './components';
const VALUE_WIDTH_PX = 140;
const SelectPickerFC = ({ value, options = [], placeholder, noOptionsPlaceholder, onChange }) => {
    const modalRef = useRef(null);
    const { isOpen, open, close } = useToggle({ isDefaultOpen: false });
    useClickOutside(modalRef, close);
    const isNoOptions = options.length === 0;
    const valueIdx = options.findIndex((opt) => opt.value === value);
    const hasPrevOption = valueIdx > 0;
    const hasNextOption = valueIdx >= 0 && valueIdx < options.length - 1;
    return (_jsxs(Flex, { gap: '8px', children: [_jsx(IconButton, { size: 'sm', "aria-label": "", variant: 'ghost', icon: _jsx(Svg, { name: 'Back' }), isDisabled: isNoOptions || !hasPrevOption, onClick: () => {
                    const prevOption = options[valueIdx - 1];
                    if (prevOption) {
                        onChange?.(prevOption.value);
                    }
                } }), _jsxs(Box, { h: '32px', position: 'relative', children: [_jsx(ValueContainer, { value: value, options: options, valueWidthPx: VALUE_WIDTH_PX, placeholder: placeholder, noOptionsPlaceholder: noOptionsPlaceholder, onClick: !isNoOptions ? open : undefined }), isOpen && (_jsx(Box, { ref: modalRef, children: _jsx(OptionsContainer, { value: value, options: options, valueWidthPx: VALUE_WIDTH_PX, onSelect: (v) => {
                                onChange?.(v);
                                close();
                            } }) }))] }), _jsx(IconButton, { size: 'sm', "aria-label": "", variant: 'ghost', icon: _jsx(Box, { transform: 'rotate(180deg)', children: _jsx(Svg, { name: 'Back' }) }), isDisabled: isNoOptions || !hasNextOption, onClick: () => {
                    const nextOption = options[valueIdx + 1];
                    if (nextOption) {
                        onChange?.(nextOption.value);
                    }
                } })] }));
};
export const SelectPicker = observer(SelectPickerFC);
//# sourceMappingURL=SelectPicker.js.map